//* Libraries imports
import { useNavigate, useParams } from 'react-router-dom';

//* Hooks imports
import { useGetProcessEditalById } from '../../../../hooks/queries/process/use-get-process-edital';
import { useGetProcessById } from '../../../../hooks/queries/process/use-get-process';

//* Components imports
import { ProcessEditalSkeleton } from '../../../../skeleton/ProcessEditalSkeleton/process-edital-skeleton';
import { ViewHeaderProcess } from '../../view/_components/view-header-process';
import { EditalContent } from './edital-content';
import { EditalEmptyState } from './edital-empty-state';
import { ErrorMessages } from '../../../../component/common/ErrorMessages';

export function Content() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const processId = id ? parseInt(id) : 0;
  const editalQuery = useGetProcessEditalById(processId);
  const processQuery = useGetProcessById(processId);
  const { isLoading: isEditalLoading, isError: isEditalError, data: editalResponse } = editalQuery;
  const { isLoading: isProcessLoading, isError: isProcessError, data: processResponse } = processQuery;

  const isLoading = isEditalLoading || isProcessLoading;
  const isError = isEditalError || isProcessError;

  if (!processId) {
    navigate(`/process/${id}`);
    return null;
  }

  const handleBack = () => {
    navigate(`/process/${id}`);
  };

  const renderMainContent = () => {
    const editalData = editalResponse!.data!;
    const hasRules = editalData.regras && editalData.regras.trim() !== '';
    const process = processResponse?.data;

    return (
      <div className="w-100">
        <ViewHeaderProcess
          processName={process?.name}
          handleBack={handleBack}
          isOnline={process?.online}
          startDate={process?.start?.human?.date}
          endDate={process?.end?.human?.date}
          collegeName={process?.college?.name}
        />

        <div className="d-flex justify-content-center">
          {hasRules ? (
            <EditalContent rules={editalData.regras} />
          ) : (
            <EditalEmptyState />
          )}
        </div>
      </div>
    );
  };

  return isLoading ? (
    <ProcessEditalSkeleton />
  ) : isError || !editalResponse?.success || !editalResponse?.data ? (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <ErrorMessages
        messages={[
          editalResponse?.message ||
            "Não foi possível carregar o edital do processo.",
        ]}
        clearErrors={handleBack}
      />
    </div>
  ) : (
    renderMainContent()
  );
}
               